export const FOOTER_COLUMNS = [
  {
    key: "product",
    links: [
      { key: "product1", href: "#" },
      { key: "product2", href: "#" },
      { key: "product3", href: "#" },
      { key: "product4", href: "#" },
    ],
  },
  {
    key: "company",
    links: [
      { key: "company1", href: "#" },
      { key: "company2", href: "/blog" },
      { key: "company3", href: "#" },
      { key: "company4", href: "#" },
    ],
  },
  {
    key: "support",
    links: [
      { key: "support1", href: "#" },
      { key: "support2", href: "#" },
      { key: "support3", href: "#faq" },
      { key: "support4", href: "#" },
    ],
  },
];

export const SOCIALS = [
  { name: "Instagram", short: "IG", href: "#" },
  { name: "Twitter", short: "X", href: "#" },
  { name: "LinkedIn", short: "in", href: "#" },
  { name: "Telegram", short: "TG", href: "#" },
];